import React, { useState } from "react";
import SkipNextIcon from "@material-ui/icons/SkipNext";
import SkipPreviousIcon from "@material-ui/icons/SkipPrevious";
import { InlineMath } from "react-katex";
import MediaQuery from "react-responsive";
import { Scrollbar } from "react-scrollbars-custom";

const Ch2 = ({ukuranH,ukuranP}) => {
	const [jawaban2, setJawaban2] = useState(false);
	const clickSetJawaban2 = () => setJawaban2(!jawaban2);
	const [show1, setShow1] = useState(false);
	const [show2, setShow2] = useState(false);
	const [show3, setShow3] = useState(false);
	const [show4, setShow4] = useState(false);

	// const [form1, setForm1] = useState({ width: "50px", height: "30px" });
	const [form2, setForm2] = useState({ width: "50px", height: "30px" });
	const [form3, setForm3] = useState({ width: "70px", height: "30px" });
	const [form4, setForm4] = useState({ width: "50px", height: "30px" });
	const [form5, setForm5] = useState({ width: "50px", height: "30px" });
	const [form6, setForm6] = useState({ width: "70px", height: "30px" });
	const [form7, setForm7] = useState({ width: "50px", height: "30px" });
	const [form8, setForm8] = useState({ width: "50px", height: "30px" });

	//barurevisi
	// const [show5, setShow5] = useState(false);
	const [show6, setShow6] = useState(false);
	const [show7, setShow7] = useState(false);
	const [show8, setShow8] = useState(false);
	const [show9, setShow9] = useState(false);
	const [show10, setShow10] = useState(false);
	const [show11, setShow11] = useState(false);
	const [show12, setShow12] = useState(false);
	const [show13, setShow13] = useState(false);

	const [form9, setForm9] = useState({ width: "50px", height: "30px" });
	const [form10, setForm10] = useState({ width: "50px", height: "30px" });
	const [form11, setForm11] = useState({ width: "50px", height: "30px" });
	const [form12, setForm12] = useState({ width: "50px", height: "30px" });
	const [form13, setForm13] = useState({ width: "50px", height: "30px" });
	// const handleform1 = (no1) => {
	// 	const jwb = no1.target.value;
	// 	if (jwb === "300") {
	// 		setForm1({
	// 			border: "6px solid #1aff66",
	// 			width: "70px",
	// 			height: "30px",
	// 		});
	// 		setShow5(true);
	// 	} else if (jwb === "") {
	// 		setForm1({
	// 			border: "6px solid yellow",
	// 			width: "70px",
	// 			height: "30px",
	// 		});
	// 	} else {
	// 		setForm1({
	// 			border: "6px solid red",
	// 			width: "70px",
	// 			height: "30px",
	// 		});
	// 	}
	// };
	const handleform2 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "1000") {
			setForm2({
				border: "6px solid #1aff66",
				width: "70px",
				height: "30px",
			});
			setShow6(true);
		} else if (jwb === "") {
			setForm2({
				border: "6px solid yellow",
				width: "70px",
				height: "30px",
			});
		} else {
			setForm2({
				border: "6px solid red",
				width: "70px",
				height: "30px",
			});
		}
	};
	const handleform3 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "2000") {
			setForm3({
				border: "6px solid #1aff66",
				width: "70px",
				height: "30px",
			});
			setShow7(true);
		} else if (jwb === "") {
			setForm3({
				border: "6px solid yellow",
				width: "70px",
				height: "30px",
			});
		} else {
			setForm3({
				border: "6px solid red",
				width: "70px",
				height: "30px",
			});
		}
	};
	const handleform4 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "400000") {
			setForm4({
				border: "6px solid #1aff66",
				width: "90px",
				height: "30px",
			});
			setShow8(true);
		} else if (jwb === "") {
			setForm4({
				border: "6px solid yellow",
				width: "90px",
				height: "30px",
			});
		} else {
			setForm4({
				border: "6px solid red",
				width: "90px",
				height: "30px",
			});
		}
	};
	const handleform5 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "1300") {
			setShow1(true);
			setForm5({
				border: "6px solid #1aff66",
				width: "70px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm5({
				border: "6px solid yellow",
				width: "70px",
				height: "30px",
			});
		} else {
			setForm5({
				border: "6px solid red",
				width: "70px",
				height: "30px",
			});
		}
	};
	const handleform6 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "2200") {
			setShow2(true);
			setForm6({
				border: "6px solid #1aff66",
				width: "70px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm6({
				border: "6px solid yellow",
				width: "70px",
				height: "30px",
			});
		} else {
			setForm6({
				border: "6px solid red",
				width: "70px",
				height: "30px",
			});
		}
	};
	const handleform7 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "0") {
			setShow3(true);
			setForm7({
				border: "6px solid #1aff66",
				width: "40px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm7({
				border: "6px solid yellow",
				width: "40px",
				height: "30px",
			});
		} else {
			setForm7({
				border: "6px solid red",
				width: "40px",
				height: "30px",
			});
		}
	};
	const handleform8 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "0") {
			setShow4(true);
			setForm8({
				border: "6px solid #1aff66",
				width: "40px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm8({
				border: "6px solid yellow",
				width: "40px",
				height: "30px",
			});
		} else {
			setForm8({
				border: "6px solid red",
				width: "40px",
				height: "30px",
			});
		}
	};

	//barurevisi
	const handleform9 = (no1) => {
		const jwb = no1.target.value;
		if (jwb.toUpperCase() === "X") {
			setShow9(true);
			setForm9({
				border: "6px solid #1aff66",
				width: "40px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm9({
				border: "6px solid yellow",
				width: "40px",
				height: "30px",
			});
		} else {
			setForm9({
				border: "6px solid red",
				width: "40px",
				height: "30px",
			});
		}
	};

	const handleform10 = (no1) => {
		const jwb = no1.target.value;
		if (jwb.toUpperCase() === "Y") {
			setShow10(true);
			setForm10({
				border: "6px solid #1aff66",
				width: "40px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm10({
				border: "6px solid yellow",
				width: "40px",
				height: "30px",
			});
		} else {
			setForm10({
				border: "6px solid red",
				width: "40px",
				height: "30px",
			});
		}
	};
	const handleform11 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "300") {
			setShow11(true);
			setForm11({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm11({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm11({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform12 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "2") {
			setShow12(true);
			setForm12({
				border: "6px solid #1aff66",
				width: "40px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm12({
				border: "6px solid yellow",
				width: "40px",
				height: "30px",
			});
		} else {
			setForm12({
				border: "6px solid red",
				width: "40px",
				height: "30px",
			});
		}
	};
	const handleform13 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "400") {
			setShow13(true);
			setForm13({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm13({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm13({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	return (
		<div
			style={{
				margin: "auto",
				lineHeight: "35px",
				textAlign: "justify",
				width: "100%",
				borderStyle: "solid",
				borderColor: "#2d8659",
				borderRadius: "25px",
				boxShadow: "5px 5px #888887",
			}}
			className="mt-2 mb-2"
		>
			<div
				style={{
					width: "80%",
					margin: "auto",
				}}
			>
				<p
					style={{
						textIndent: "2rem",
						width: "100%",
						textAlign: "justify",
						lineHeight: "35px",
						fontSize :`${ukuranP}px`
					}}
				>
					Lia membeli kue A dengan harga Rp 1.000,00 dan kue B dengan harga Rp
					2.000,00. Modal yang dimiliki Lia tidak lebih dari Rp 400.000,00. Lia
					dapat menjual kue A dengan harga Rp 1.300,00 dan kue B dengan harga Rp
					2.200,00. Lia hanya dapat menjual kedua kue sebanyak 300 buah sehari.
					Buatlah model matematika dari permasalahan Lia membeli dan menjual
					kue?
				</p>
			</div>
			<div
				style={{
					marginLeft: "1rem",
					color: "green",
					display: "flex",
					justifyContent: "space-between",
					width: "10%",
				}}
			>
				<div
					style={{
						width: "5px",
						height: "5px",
						animation: "scrollTop 0.3s alternate ease infinite",
					}}
				>
					<SkipNextIcon />
				</div>
				<p
					style={{ marginLeft: "22px", cursor: "pointer" }}
					onClick={clickSetJawaban2}
				>
					<strong>
						<u>Jawaban</u>
					</strong>
				</p>
				<div
					style={{
						width: "5px",
						height: "5px",
						animation: "scrollTop 0.2s alternate ease infinite",
					}}
				>
					<SkipPreviousIcon />
				</div>
			</div>
			{jawaban2 ? (
				<div
					style={{
						margin: "auto",
						width: "80%",
						position: "relative",
						textAlign: "justify",
					}}
				>
					<ol style={{fontSize:`${ukuranP}px`}}>
						<li>Pertama kita buat tabel, agar memudahkan kita dalam menyusun model matematikanya! </li>
						<MediaQuery minWidth={476} maxWidth={1824}>
							<div>
								<table
									className="table"
									style={{
										border: "2px solid green",
										borderCollapse: "collapse",

										textAlign: "center",
									}}
								>
									<tr>
										<th
											style={{
												border: "2px solid green",
											}}
										>
											Pembatas
										</th>
										<th
											style={{
												border: "2px solid green",
											}}
										>
											Kue A
										</th>
										<th
											style={{
												border: "2px solid green",
											}}
										>
											Kue B
										</th>
										<th
											style={{
												border: "2px solid green",
											}}
										>
											Total
										</th>
									</tr>

									{/* <tr>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											Penjualan
										</td>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											1
										</td>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											1
										</td>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											<input type="text" style={form1} onChange={handleform1} />
										</td>
									</tr> */}

									<tr>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											Harga Beli/Modal
										</td>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											<input type="text" style={form2} onChange={handleform2} />
										</td>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											<input type="text" style={form3} onChange={handleform3} />
										</td>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											<input type="text" style={form4} onChange={handleform4} />
										</td>
									</tr>
									<tr>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											Harga Jual
										</td>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											<input type="text" style={form5} onChange={handleform5} />
										</td>
										<td
											style={{
												border: "2px solid green",
											}}
										>
											<input type="text" style={form6} onChange={handleform6} />
										</td>
										<td
											style={{
												border: "2px solid green",
											}}
										></td>
									</tr>
								</table>
							</div>
						</MediaQuery>
						<MediaQuery maxWidth={475}>
							<Scrollbar style={{ width: "80%", height: 300 }}>
								<div>
									<table
										className="table"
										style={{
											border: "2px solid green",
											borderCollapse: "collapse",

											textAlign: "center",
										}}
									>
										<tr>
											<th
												style={{
													border: "2px solid green",
												}}
											>
												Pembatas
											</th>
											<th
												style={{
													border: "2px solid green",
												}}
											>
												Kue A
											</th>
											<th
												style={{
													border: "2px solid green",
												}}
											>
												Kue B
											</th>
											<th
												style={{
													border: "2px solid green",
												}}
											>
												Total
											</th>
										</tr>

										{/* <tr>
											<td
												style={{
													border: "2px solid green",
												}}
											>
												Penjualan
											</td>
											<td
												style={{
													border: "2px solid green",
												}}
											>
												1
											</td>
											<td
												style={{
													border: "2px solid green",
												}}
											>
												1
											</td>
											<td
												style={{
													border: "2px solid green",
												}}
											>
												<input
													type="text"
													style={form1}
													onChange={handleform1}
												/>
											</td>
										</tr> */}

										<tr>
											<td
												style={{
													border: "2px solid green",
												}}
											>
												Harga Beli/Modal
											</td>
											<td
												style={{
													border: "2px solid green",
												}}
											>
												<input
													type="text"
													style={form2}
													onChange={handleform2}
												/>
											</td>
											<td
												style={{
													border: "2px solid green",
												}}
											>
												<input
													type="text"
													style={form3}
													onChange={handleform3}
												/>
											</td>
											<td
												style={{
													border: "2px solid green",
												}}
											>
												<input
													type="text"
													style={form4}
													onChange={handleform4}
												/>
											</td>
										</tr>
										<tr>
											<td
												style={{
													border: "2px solid green",
												}}
											>
												Harga Jual
											</td>
											<td
												style={{
													border: "2px solid green",
												}}
											>
												<input
													type="text"
													style={form5}
													onChange={handleform5}
												/>
											</td>
											<td
												style={{
													border: "2px solid green",
												}}
											>
												<input
													type="text"
													style={form6}
													onChange={handleform6}
												/>
											</td>
											<td
												style={{
													border: "2px solid green",
												}}
											></td>
										</tr>
									</table>
								</div>
							</Scrollbar>
						</MediaQuery>
						{show1 && show2 && show6 && show7 && show8 ? (
							<div>
								<li>
									<p>Dengan memisalkan :</p>
									<p className="text-center alert alert-warning h6">
										Kalian harus menyesuaikan seperti contoh soal sebelumnya
									</p>
									<ul>
										<li>
											<input type="text" style={form9} onChange={handleform9} />{" "}
											= banyaknya kue A
										</li>
										<li>
											<input
												type="text"
												style={form10}
												onChange={handleform10}
											/>{" "}
											= banyaknya kue B
										</li>
									</ul>
								</li>
								{show9 && show10 ? (
									<>
										<li>
											<p>Karena Lia hanya dapat menjual 300 buah dalam satu hari, maka :</p>
											<p>
												<InlineMath math="\iff" />
												<i>
													<b>
														x + y ≤{" "}
														<input
															type="text"
															style={form11}
															onChange={handleform11}
														/>{" "}
													</b>
												</i>
											</p>
										</li>
										{show11 ? (
											<>
												<li>
													<p>
														Harga kue yang dibeli Lia :{" "}
													</p>
													<p>
													<InlineMath math="\iff" />
														<i>
															{" "}
															<b>1000x + 2000y ≤ 400.000 </b>{" "}
														</i>{" "}
													</p>
													<p><InlineMath math="\iff"/> Disederhanakan menjadi :</p>
													<p>
													<InlineMath math="\iff" />
														<i>
															<b>x + <input
															type="text"
															style={form12}
															onChange={handleform12}
														/>y ≤ <input
														type="text"
														style={form13}
														onChange={handleform13}
													/> </b>
														</i>
													</p>
												</li>
										{show12&&show13?
										<>

<li>
	Karena tidak mungkin banyaknya kue negatif, sehingga dapat
	dituliskan{" "}
	<b>
		<i>
			x ≥{" "}
			<input
				type="text"
				style={form7}
				onChange={handleform7}
			/>
		</i>
	</b>{" "}
	dan{" "}
	<b>
		<i>
			y ≥{" "}
			<input
				type="text"
				style={form8}
				onChange={handleform8}
			/>
		</i>
	</b>{" "}
</li>
{show3 && show4 ? (
	<div>
		<li>Maka model matematikanya adalah</li>
		<div className="text-center mt-1">
			<InlineMath math=" x + y ≤ 300  ; " />&nbsp;&nbsp;
			<InlineMath math=" x + 2y ≤ 400;  " />&nbsp;&nbsp;
			<InlineMath math=" x ≥ 0 ; y ≥ 0" />
		</div>
	</div>
) : null}
										</>
										:null}
											</>
										) : null}
									</>
								) : null}
							</div>
						) : null}
					</ol>
				</div>
			) : null}
		</div>
	);
};

export default Ch2;
